<mat-form-field appearance="outline">
  <input 
    matInput
    type="text"
    [formControl]="searchInput"
    [matAutocomplete]="auto"
    placeholder="Search"
    #searchRef
    (keyup.enter)="filterSearch(searchInput.value)"
  />
  <button
    matSuffix
    mat-icon-button
    aria-label="search"
    (click)="filterSearch(searchInput.value)"
  >
    <mat-icon>search</mat-icon>
  </button>
  <mat-autocomplete 
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onSearchSelect($event.option)">
    <mat-option *ngFor="let option of filteredOptions" [value]="option">
      {{ option.itineraryName }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
